export const isDevelopment = process.env.NODE_ENV !== 'production';

export const logDevelopmentError = (error: Error): void => {
  if (isDevelopment) console.log(error);
};
